import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GetCompareStatusResponse, ItemGroupResult, ItemResult } from '../../models/importer-status';
import { ImportDisplayHelper } from '../../helpers/import-display-helper';
import { PermissionRequiredDirective } from '../../../shared/authentication/permission-required.directive';


@Component({
    selector: 'app-developer-import-confirm',
    templateUrl: './developer-import-confirm.component.html',
    styleUrls: ['./developer-import-confirm.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, PermissionRequiredDirective]
})
export class DeveloperImportConfirmComponent implements OnInit, AfterViewInit {
  formData: UntypedFormGroup;

  @Input() compareStatus: GetCompareStatusResponse;
  @Input() versionMismatchDetected: boolean;
  @Output() goImport = new EventEmitter();
  @Output() goCancel = new EventEmitter();

    constructor(private fb: UntypedFormBuilder, private importDisplayHelper: ImportDisplayHelper) { }

  ngOnInit(): void {
    this.formData = this.buildForm();
  }

  ngAfterViewInit(): void {
    console.log(this.compareStatus);
  }

  buildForm(): UntypedFormGroup {
    return this.fb.group({
    });
  }

  canImport(): boolean {
    for( var i = 0; i < this.compareStatus.Result.ItemGroupResults.length; i++){ 
      if (this.compareStatus.Result.ItemGroupResults[i].ItemResults[0].Status === "MissingPermission") {
          return false;
      }
      if (this.compareStatus.Result.ItemGroupResults[i].ItemResults[0].Status === "BlockImport") {
        return false;
      }
    }
    return this.formData.valid && this.compareStatus.Result.ItemGroupResults.length > 0;
  }

  import(): void {
    if (this.formData.valid) {
      this.goImport.emit();
    }
  }

  cancel(): void {
    this.goCancel.emit();
  }

    getGroupName(group: ItemGroupResult): string {
        return this.importDisplayHelper.getDisplayName(this.compareStatus.Result.ItemGroupResults, group.ObjectType);
  }

  getGroupStatusMessage(group: ItemGroupResult): string[] {
    return group.ItemResults.filter(x => x.StatusMessage?.length > 0).map(x => x.StatusMessage);
    }

    getItemStatusMessage(item: ItemResult): string {
        return item.StatusMessage;
    }

    getItemName(item: ItemResult): string {
      return this.importDisplayHelper.getDisplayName(this.compareStatus.Result.ItemGroupResults, item.ObjectType, item);
    }

    formatText(inputString: string, displayString: string): string {
      if (displayString?.length > 0) {
        inputString = displayString;
      }
        if (inputString.toString().length < 400) {
            return inputString;
        }
        const chunkSize: number = 1000; // the size of each chunk
        let index: number = 0;
        let isBase64: boolean = true;

        while (index < inputString.toString().length && isBase64) {
            const chunk: string = inputString.substr(index, chunkSize);
            let decodedChunk: string;

            try {
                decodedChunk = atob(chunk);
            }
            catch (e) {
                isBase64 = false;
            }

            if (isBase64 && chunk !== btoa(decodedChunk)) {
                isBase64 = false;
            }

            index += chunkSize;
        }

        if (isBase64) {
            return "(base64 data hidden)";
        }
        else {
            return inputString
        }
    }

}
